import React, { useEffect } from 'react';
import Nprogress from 'nprogress';
import 'nprogress/nprogress.css';

import CircularProgress from '../CircularProgress';

Nprogress.configure({ showSpinner: false });

function Loading() {
  useEffect(() => {
    Nprogress.start();

    return () => {
      Nprogress.done();
    };
  }, []);

  return <CircularProgress />;
}

export default Loading;
